<template>
    <div>
        <div class="px-5">
            <v-card-title v-if="rundenName" class="pt-0 pl-0 grey--text text--darken-2">{{rundenName}}
            <v-spacer/>
            <v-btn v-if="runde.settings.modus === 'ko' && isOperator && !bewerb.isConfirmed()"
                   icon @click="editSettings">
                <v-icon>mdi-cog</v-icon>
            </v-btn>
            <v-btn v-if="isOperator && !bewerb.isConfirmed() &&
                      runde.tabNameIsChangeable(bewerb.getNumberOfRunden())"
                   icon @click="confirmAddEditRunde(false)">
                <v-icon class="mr-1">mdi-pencil</v-icon>
            </v-btn>
            <v-btn v-if="isOperator && !bewerb.isConfirmed() &&
                              runde.isDeleteable(bewerb.getNumberOfRunden())"
                   icon @click="confirmDeleteRunde()">
                <v-icon class="mr-1">mdi-delete</v-icon>
            </v-btn>
            <v-btn v-if="isOperator && runde.settings.modus === 'tabelle'"
                   icon @click="exportToExcel()">
                <v-icon class="mr-1">mdi-download</v-icon>
            </v-btn>
            </v-card-title>
        <!-- accessable with account and role-->
            <v-card-title v-if="isOperator" class="pa-0">
                <v-btn v-if="runde.showAddTeamButton()"
                       :disabled="bewerb.isConfirmed()"
                       color="primary" @click="addTeam()" class="mr-5 mb-3">
                    <v-icon>mdi-plus</v-icon>{{teamLabelSingular}} hinzufügen
                </v-btn>
                <v-btn v-if="runde.isOpenForAddRound(bewerb.getNumberOfRunden())"
                       :disabled="bewerb.isConfirmed()" class="mr-5 mb-3"
                       color="primary" @click="confirmAddEditRunde(true)">
                    <v-icon class="mr-1">mdi-table-plus</v-icon>Runde hinzufügen
                </v-btn>
                <!---->
                <v-btn v-if="!bewerb.isConfirmed() &&
                             previousRunde"
                       :disabled="(previousRunde.settings.modus === 'tabelle' && runde.settings.modus === 'ko' &&
                                 (!previousRunde.isComplete() || runde.teamsNotEmpty())) ||
                                 (previousRunde.settings.modus === 'tabelle' && runde.settings.modus === 'tabelle' &&
                                  !previousRunde.isComplete()) ||
                                 runde.isComplete()"
                       @click="requestActionConfirm()"
                       color="primary"
                       class="mr-5 mb-3">
                    <v-icon>mdi-arrow-down-bold</v-icon>Aus Vorrunde füllen
                </v-btn>
                <v-spacer/>
                <v-btn v-if="isOperator && runde.settings.modus === 'tabelle' && !rundenName"
                       icon @click="exportToExcel()">
                    <v-icon class="mr-1">mdi-download</v-icon>
                </v-btn>
            </v-card-title>
        <!-- confirm dialog -->
            <confirm-dialog :open="confirmRundenAction.open" :header="confirmRundenAction.header"
                            @reply="processConfirm" :query-parameter="'confirmRundenAction'+runde.id"
                            :button-yes="confirmRundenAction.btnYes" :button-no="confirmRundenAction.btnNo"
                            :without-router="true">
                {{ confirmRundenAction.question }}
                <span v-if="runde.settings.modus==='tabelle'">
                    <v-text-field v-model="copyUntilPosition" label="Übernahme bis Platz" type="number" class="mt-2"/>
                    <v-alert v-if="!copyUntilPosition || copyUntilPosition==='0'" text color="error" icon="mdi-alert">
                        Bitte eine Platzierung eingeben</v-alert>
                </span>
            </confirm-dialog>
            <confirm-dialog :open="deleteRundenAction.open" :header="deleteRundenAction.header"
                            @reply="deleteRunde" :query-parameter="'confirmRundenDelete'+runde.id">
                {{ deleteRundenAction.question }}
                <!--<v-text-field v-model="rundenNameNew" label="Rundenname"/>-->
            </confirm-dialog>
            <confirm-dialog :open="addRundenAction.open" :header="addRundenAction.header"
                            button-yes="Speichern" button-no="Abbrechen"
                            @reply="addEditRunde" :query-parameter="'confirmRundenAdd'+runde.id">
                {{ addRundenAction.question }}
                <v-text-field v-model="rundenNameNew" label="Rundenname"/>
                <v-alert v-if="!rundenNameNew" text color="error" icon="mdi-alert">
                    Bitte einen Rundennamen eingeben!</v-alert>
            </confirm-dialog>
        </div>
    </div>
</template>

<script>
import ConfirmDialog from "@/components/navigation/confirmDialog.vue";
import EXCEL_DOWNLOAD from "@/utilities/services/downloads/excel/excelDownload";
import TimeStamp from "@/services/timeStamp";

export default {
    name: "meisterschaftRundeAktionen",
    components: {ConfirmDialog},
    props: ['runde', 'landesverbandId', 'bewerb'],
    computed: {
        isOperator(){ return this.$store.getters["user/isMeisterschaftOperator"](this.landesverbandId)},
        teamLabelSingular(){ return this.bewerb?.getTeamLabel().singular },
        previousRunde(){ return this.bewerb.getPreviousRunde(this.runde.id) },
        rundenName(){
            if ( this.runde.settings.name ) return this.runde.settings.name
            return this.bewerb.getRundenNameFromTab(this.runde.id)
        }
    },
    data: () => ({
        rundenNameNew: '',
        copyUntilPosition: '',
        confirmRundenAction: {
            open: false,
            header: 'Teams aus Vorrunde füllen',
            question: 'Möchtest du die qualifizierten Teams aus der Vorrunde wirklich in diese Runde übernehmen?',
            btnYes: 'Ja',
            btnNo: 'Nein',
        },
        deleteRundenAction: {
            open: false,
            header: 'Runde endgültig löschen',
            question: 'Möchtest du die gewählte Runde endgültig und unwiderruflich inklusive aller bereits eingegebenen ' +
                'Ergebnisse löschen?',
        },
        addRundenAction: {
            open: false,
            header: 'Runde endgültig löschen',
            question: '',
            isAdd: false,
        },
    }),
    methods: {
        addTeam(){
            this.$emit('addTeam');
        },
        confirmAddEditRunde(isAdd){
            this.addRundenAction.header = isAdd ? 'Neue Runde hinzufügen' : 'Rundenname ändern'
            this.addRundenAction.open = true
            this.addRundenAction.isAdd = isAdd
            if( !isAdd ) {
                const current = this.bewerb.getTabs().find(tab => tab.rundenIds.includes(this.runde.id))
                this.rundenNameNew = current.title
            }
        },
        async addEditRunde(reply){
            if ( reply && !this.rundenNameNew ) return
            if ( reply ) {
                if ( this.addRundenAction.isAdd ) {
                    await this.bewerb.addTabRunde(this.rundenNameNew)
                } else {
                    await this.bewerb.editTabRunde(this.runde.id, this.rundenNameNew)
                }
            }
            this.rundenNameNew = '';
            this.isAdd = false;
            this.addRundenAction.open = false;
        },
        editSettings(){
            this.$emit('editSettings');
        },
        confirmDeleteRunde(){
            this.deleteRundenAction.open = true;
        },
        async deleteRunde(reply){
            if ( reply ) await this.bewerb.deleteTabRunde(this.runde.id)
            this.deleteRundenAction.open = false;
        },
    // change confirmation status for runde
        requestActionConfirm(){
            if ( this.runde.settings.modus === 'ko' ) {
                this.confirmRundenAction.header = 'Teams aus Vorrunde füllen'
                this.confirmRundenAction.question = 'Möchtest du die qualifizierten Teams aus der Vorrunde wirklich in diese Runde übernehmen?'
                this.confirmRundenAction.btnYes = 'Ja'
                this.confirmRundenAction.btnNo = 'Nein'
            } else {
                this.confirmRundenAction.header = 'Runde aus Vorrunde füllen'
                this.confirmRundenAction.question = 'Möchtest du wirklich Personen aus der vorherigen Runde in diese ' +
                    'Runde übernehmen? ACHTUNG: es werden alle aktuellen Eingaben in dieser Runde inklusive Ergebnissen ' +
                    ' gelöscht!'
                this.confirmRundenAction.btnYes = 'Übernehmen'
                this.confirmRundenAction.btnNo = 'Abbrechen'
            }
            this.confirmRundenAction.open = true;
        },
        async processConfirm(reply) {
            if ( reply && this.runde.settings.modus === 'ko' ) await this.runde.fillFromPreviousRunde(
                    this.previousRunde, this.bewerb?.id, this.bewerb.settings)
            if ( this.runde.settings.modus === 'tabelle' ) {
                if ( reply && !this.copyUntilPosition || this.copyUntilPosition === '0' ) return
                if ( reply ) await this.runde.fillFromPreviousRunde(this.previousRunde, this.copyUntilPosition, this.bewerb?.id,)
            }
            this.confirmRundenAction.open = false;
        },
    // excel download
        exportToExcel(){
            const teamsRaw = this.runde.getTeamList()
            const teams = teamsRaw.map(team => ({
                pos: team.results.position,
                name: team.settings.name,
                verein: team.settings.vereinsName,
                lv: team.settings.landesverband,
                klasse: team.settings.ak,
                volle: team.results.volle,
                ar: team.results.abraeumen,
                fw: team.results.fehlwuerfe,
                ges: team.results.gesamt,
            }))
            EXCEL_DOWNLOAD.exportJsonToSingleSheet(
                teams,
                'MeisterschaftsErgebnis',
                TimeStamp.getTodayString(),
                [
                    {text:'Pos', value:'pos'},
                    {text:'Name', value:'name'},
                    {text:'Verein', value:'verein'},
                    {text:'LV', value:'lv'},
                    {text:'Klasse', value:'klasse'},
                    {text:'Volle', value:'volle'},
                    {text:'AR', value:'ar'},
                    {text:'FW', value:'fw'},
                    {text:'Ges', value:'ges'},
                ]
            );
        },
    },
}
</script>

<style scoped>

</style>